export enum TargetedDisplay {
  Desktop = 'desktop',
  Mobile = 'mobile',
  Tablet = 'tablet',
}
